export default function step05RenewalsReducer(
    state: any = {
        loading: false,
        done: false,
        error: null,
        response: [
            {
                'id': 1,
                'commission': 5.0,
                'excess': 500,
                'money': null,
                'glass': null,
                'cancellationCover': null,
                'defectiveTitle': null,
                'personalAccident': null,
                'unattendedVehicleCover': null,
                'terrorism': false,
                'shoplifting': false,
                'isIssued': true,
                'premium': null,
            },
        ],
        subjectivities: [],
    },
    action: any) {

    switch (action.type) {

        case 'GET_STEP05_RENEWALS_VAR_PENDING': {
            return { ...state, loading: true }
        }

        case 'GET_STEP05_RENEWALS_VAR_REJECTED': {
            return { ...state, loading: false, error: action.payload }
        }

        case 'GET_STEP05_RENEWALS_VAR_FULFILLED': {

            let resp = action.payload.quoteVariations
            let subjectivities = action.payload.subjectivities
            let commissionList = action.payload.commissionList
            let maxComi = action.payload.maxCommission
            let maxHccComi = action.payload.maxHccCommission
            let maxHiscoxComi = action.payload.maxHiscoxCommission
            let minComi = action.payload.minCommision
            let maxExcess = action.payload.maxExcession
            let minExcess = action.payload.minExcession

            resp.sort(function (a: any, b: any) {
                return parseFloat(a.id) - parseFloat(b.id)
            })

            return {
                ...state,
                loading: false,
                done: true,
                error: null,
                response: resp,
                subjectivities: subjectivities,
                commissionList: commissionList ? commissionList : '',
                maxCommission: maxComi ? maxComi : '',
                maxHccCommission: maxHccComi ? maxHccComi : '',
                maxHiscoxCommission: maxHiscoxComi ? maxHiscoxComi : '',
                minCommission: minComi ? minComi : '',
                maxExcession: maxExcess ? maxExcess : '',
                minExcession: minExcess ? minExcess : '',
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/quote/renewalStep05.ts